import { ZButton } from "@/shared/components/button";
import ModalCloseIcon from "@/shared/icons/modal-close";
import { Modal, ModalBody, ModalContent, ModalHeader } from "@nextui-org/react"; // Spinner removed as isLoading is local
import { useState } from "react";
import ShadowExcalamationIcon from "@/shared/icons/shadow-exclamation";
import { ZModalFooter } from "@/shared/components/modal";
// ChatHistoryInterface import removed as it's no longer used directly in props

interface DiscardSessionModalProps {
  isOpen: boolean;
  toggleModal: () => void;
  sessionName: string;
  onConfirm: () => void;
  isLoading?: boolean; // Add this prop
}

const DiscardSessionModal = ({ 
  isOpen, 
  toggleModal, 
  sessionName, 
  onConfirm,
  isLoading = false // Default to false
}: DiscardSessionModalProps) => {
  const [localIsLoading, setLocalIsLoading] = useState(isLoading);

  const handleConfirmDiscard = () => { // Renamed from handleDelete
    setLocalIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      onConfirm(); // Call the passed onConfirm function
      toggleModal();
      setLocalIsLoading(false);
    }, 1500);
  }

  return (
    <Modal isOpen={isOpen} size="md" hideCloseButton={true} onClose={toggleModal}>
      <ModalContent>
        <ModalHeader className="self-center">
          <button role="button" aria-label="Close" onClick={toggleModal}
            className="absolute appearance-none select-none top-1 right-1 rtl:left-1 rtl:right-[unset] p-2 text-foreground-500 
        rounded-full hover:bg-default-100 active:bg-default-200 tap-highlight-transparent outline-none data-[focus-visible=true]:z-10 
        data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 text-[16px] wei"
            type="button">

            <ModalCloseIcon />
          </button>
          <div className="flex flex-col items-center justify-center gap-2">
            <p className="text-[20px] font-medium">
              Discard Session?
            </p>
          </div>
        </ModalHeader>
        <ModalBody className="self-center items-center justify-center w-full">
          <p className="text-center text-sm text-gray-500">Are you sure you want to discard 
            <span className="text-medium text-black"> {sessionName}</span> from sessions?</p> {/* Changed text and used sessionName */}

          <ShadowExcalamationIcon />

          <p className="text-sm text-gray-500 text-center">Once discarded, this session’s activity cannot be recovered, and the form sent to the vendor will no longer be valid.</p> {/* Changed text */}

        </ModalBody >
        <ZModalFooter className="w-full justify-stretch">
          <ZButton
            variant="bordered"
            onClick={toggleModal} // Changed from () => toggleModal()
            className="flex-auto"
          >
            Cancel
          </ZButton>
          <ZButton
            isLoading={localIsLoading}
            onClick={handleConfirmDiscard} // Changed from () => void handleDelete()
            disabled={localIsLoading}
            className="flex-auto"
            color="danger"
          >
            Yes, Discard {/* Changed text */}
          </ZButton>
        </ZModalFooter>
      </ModalContent >
    </Modal >
  );
};

export default DiscardSessionModal;